//#region Libraries
//#endregion
//#region Styles
//#endregion
//#region Components
import { ContainerParts } from "components/styles";
import LocationPartForm from "views/components/LocationPartForm/LocationPartForm";
import PublicPartForm from "views/components/PublicPartForm/PublicPartForm";
//#endregion

const Step2 = ({
    dataRelatedToForm: {
        locations,
        allCampusDetail, allCampus,
        modalities
    }, form, errors, 
    changeForm,
    isAsesoria
}) => {
    const changeFieldPart1 = (field, value, errorValue) => {
        changeForm("part1", field, value, errorValue);
    }
    const changeFieldPart2 = (field, value, errorValue) => {
        changeForm("part2", field, value, errorValue);
    }
    return (
        <ContainerParts>
            <LocationPartForm
                form={form.part1}
                formPart2={form.part2}
                changeField={changeFieldPart1}
                changeFieldPart2={changeFieldPart2}
                errors={errors.part1}
                locations={locations}
                allCampus={allCampusDetail}
                campus={allCampus}
                as="asesoría"
                onlyInCampus
                isAsesoria />
            {
                !isAsesoria &&
                <PublicPartForm 
                    form={form.part2}
                    formCampus={form.part1}
                    changeField={changeFieldPart2}
                    errors={errors.part2}
                    allCampus={allCampus}
                    modalities={modalities}
                    as="asesoría"
                    isAsesoria={isAsesoria}
                />
            }
        </ContainerParts>
    );
}

export default Step2;